import { find } from 'lodash';
import React from 'react';
import { Link } from 'react-router';

const TABS = {
  Drafts: 'Drafts',
  Scheduled: 'Scheduled',
  Published: 'Published',
  Archived: 'Archived',
};

type TabMenuProps = {
  creatorId: number;
};

export class WorkoutsTabs extends React.Component<TabMenuProps> {
  getInfluencerId = () => {
    return this.props.creatorId;
  };

  TABS = [
    {
      name: TABS.Drafts,
      link: (influencerId) => `/admin/partner/${influencerId}/workouts/drafts`,
    },
    {
      name: TABS.Scheduled,
      link: (influencerId) =>
        `/admin/partner/${influencerId}/workouts/scheduled`,
    },
    {
      name: TABS.Published,
      link: (influencerId) =>
        `/admin/partner/${influencerId}/workouts/published`,
    },
    {
      name: TABS.Archived,
      link: (influencerId) =>
        `/admin/partner/${influencerId}/workouts/archived`,
    },
  ];

  render() {
    const activeTab =
      find(Object.values(TABS), (v) =>
        window.location.href.includes(v.toLowerCase()),
      ) || TABS.Published;

    return (
      <section className="workoutTabMenu">
        <div className="workoutTabSelector">
          {this.TABS.map((tab) => (
            <Link
              key={tab.name}
              to={tab.link(this.getInfluencerId())}
              className={tab.name === activeTab ? 'active' : ''}
            >
              {tab.name}
            </Link>
          ))}
        </div>
      </section>
    );
  }
}
